var _style, _rect, _line, _line2, _path, _path2, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsepticDisconnector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgcontent",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.asepticDisconnector-st0{fill:#FFFFFF;stroke:currentColor;stroke-miterlimit:30;}\r\n\t.asepticDisconnector-st1{fill:none;stroke:currentColor;stroke-miterlimit:10;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "svg_2_00000006698894727627678160000001222845727458132363_",
    x: 3.1,
    y: 33,
    className: "asepticDisconnector-st0",
    width: 73.9,
    height: 13.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "asepticDisconnector-st1",
    x1: 56.4,
    y1: 46.8,
    x2: 42.6,
    y2: 33
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "asepticDisconnector-st1",
    x1: 56.4,
    y1: 33,
    x2: 42.6,
    y2: 46.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "asepticDisconnector-st1",
    d: "M49.5,49.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "asepticDisconnector-st1",
    d: "M49.5,30.5"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "49.5,39.4 55.5,33.4 43.5,33.4 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "49.5,40.4 43.5,46.4 55.5,46.4 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsepticDisconnector);
export default __webpack_public_path__ + "static/media/asepticDisconnector.363d5986811e419d35d53a8fcd4b581b.svg";
export { ForwardRef as ReactComponent };